import { makeStyles } from "@material-ui/core/styles";

const appBarHeight = 76;

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    padding: 0,
    paddingTop: appBarHeight,
    overflowY: "hidden",
  },

  table: {
    display: 'flex',
    flexDirection: 'column',
    width: "100%",
    height: "100%",
  },

  tableBody: {
    flex: 1,
    width: "100%",
    overflowY: "auto",
  },

  tableCell: {
    fontSize: 12,
    fontWeight: 600,
  },

  tableColumn2: {
    width: 304,
    paddingRight: 10,
  },

  tableRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    height: 45,
    paddingLeft: 28,
    paddingRight: 20,
    marginBottom: 10,
    borderRadius: 14,
    backgroundColor: "#FFF",
  },

  filterSector: {
    flex: '1 1 220px',
    minWidth: 0,
    '& > div, & > div > div, & .ant-select': {
      width: '100%',
    },
  },

  filterLabel: {
    display: 'block',
    marginBottom: 5,
    color: '#000',
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 'normal',
  },

  dateField: {
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: 6,
      backgroundColor: '#FFF',
      fontSize: 14,
    },
    '& .MuiOutlinedInput-input': {
      boxSizing: 'border-box',
      height: 40,
      minWidth: 0,
      padding: '0 12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d9d9d9',
    },
    '& input::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
    },
  },

  line: {
    borderTop: 0.2,
    width: '100%',
    borderColor: '#C1C1C5'
  },

  placeHolder: {
    color: '#000000',
    fontSize: 12,
  },
  containerFilter: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: 20,
    padding: '40px 0 20px',
  }
}));

export default useStyles;
